import { useTranslation } from 'react-i18next';

import { PageLayout } from 'coreOld/components';
import { RequestHome } from 'support/components';

const RequestHomePage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t('titleTssAtsSupportRequestPlain')}
      hasSubHeader={false}
      hasSearchBar={false}
      isHeaderFixed
      triggerSignInModal
    >
      <RequestHome />
    </PageLayout>
  );
};

export default RequestHomePage;
